'use strict';

var api = require('./types/api.cjs.js');
var util = require('./permissions/util.cjs.js');
var createPermission = require('./permissions/createPermission.cjs.js');
var PermissionClient = require('./PermissionClient.cjs.js');



exports.AuthorizeResult = api.AuthorizeResult;
exports.isCreatePermission = util.isCreatePermission;
exports.isDeletePermission = util.isDeletePermission;
exports.isPermission = util.isPermission;
exports.isReadPermission = util.isReadPermission;
exports.isResourcePermission = util.isResourcePermission;
exports.isUpdatePermission = util.isUpdatePermission;
exports.toPermissionEvaluator = util.toPermissionEvaluator;
exports.createPermission = createPermission.createPermission;
exports.PermissionClient = PermissionClient.PermissionClient;
//# sourceMappingURL=index.cjs.js.map
